/* ==========================================================================
   STF DIAMONDS — custom-page.js
   3-step custom request modal (SPEC §9). Progressive: without JS all steps
   render stacked and the form still posts to /contact.
   ========================================================================== */
(function () {
  'use strict';

  function initRequestModal(root) {
    if (root.dataset.reqmInit) return;
    root.dataset.reqmInit = 'true';

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-reqm-step]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-reqm-dot]'));
    var back = root.querySelector('[data-reqm-back]');
    var next = root.querySelector('[data-reqm-next]');
    var submit = root.querySelector('[data-reqm-submit]');
    if (!steps.length || !next) return;

    var current = 0;

    function fillSummary() {
      var map = {
        name: root.querySelector('[name="contact[name]"]'),
        piece: root.querySelector('[name="contact[Piece Type]"]:checked'),
        vision: root.querySelector('[name="contact[Your Vision]"]')
      };
      var nameOut = root.querySelector('[data-reqm-sum="name"]');
      var pieceOut = root.querySelector('[data-reqm-sum="piece"]');
      var visionOut = root.querySelector('[data-reqm-sum="vision"]');
      if (nameOut && map.name) nameOut.textContent = map.name.value || '—';
      if (pieceOut) pieceOut.textContent = map.piece ? map.piece.value : '—';
      if (visionOut && map.vision) visionOut.textContent = map.vision.value || '—';
    }

    function show(index) {
      current = Math.max(0, Math.min(index, steps.length - 1));
      steps.forEach(function (step, i) { step.hidden = i !== current; });
      dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i <= current); });
      if (back) back.hidden = current === 0;
      next.hidden = current === steps.length - 1;
      if (submit) submit.hidden = current !== steps.length - 1;
      if (current === steps.length - 1) fillSummary();
      var focusable = steps[current].querySelector('input, textarea, select');
      if (focusable) focusable.focus({ preventScroll: true });
    }

    function stepValid() {
      var fields = steps[current].querySelectorAll('input, textarea, select');
      for (var i = 0; i < fields.length; i++) {
        if (!fields[i].checkValidity()) {
          fields[i].reportValidity();
          return false;
        }
      }
      return true;
    }

    next.addEventListener('click', function () {
      if (stepValid()) show(current + 1);
    });
    if (back) {
      back.addEventListener('click', function () { show(current - 1); });
    }
    root.addEventListener('overlay:open', function () { show(0); });

    show(0);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-custom-request]').forEach(initRequestModal);
  }

  initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
